// Add Ethereum addresses to the ban list to prevent their 3Box profile from appearing.

export const blacklist = [
	"0x0eg",
	"0x1eg"
]